const getPageLink = (page: any) => (page ? `${page?.parent_page?.slug ? `/${page?.parent_page?.slug}` : ""}/${page?.slug}/` : undefined)

export default getPageLink
